// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zgPp","title":"styles_title__3G37j"};